import {getInvoiceQuery} from './get-invoice'

export const InvoiceQueries = {
  getInvoiceQuery
}